<div class="card browser-table">
  <div class="card-header pb-0">
    <h3>Сигнали</h3>
    <div class="card-header-right">
      <ul class="list-unstyled card-option"></ul>
    </div>
  </div>
  <div class="card-body">
    <div class="card-columns" style="column-gap: 0.25rem; row-gap: 0.25rem;">
      <ng-container *ngFor="let signal of signalsList">
        <div class="card" [ngClass]="{ 'selected': signal === selectedSignal }" (click)="onSelectedSignal(signal)">
          <div class="card-body">
            <h5 class="card-title">
              <i class="fa fa-map-marker"></i> {{ signal.title }}
            </h5>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
